import { useLocale } from '@lessonup/client-integration';
import { PinTag, PinText, PollEmojiButton } from '@lessonup/pin-renderer';
import { PollPinEmojiAnswer } from '@lessonup/pins-shared';
import { PollPinAnswerDistribution } from '@lessonup/players-modern';
import { css, SpaceBetween, spacing, styled } from '@lessonup/ui-components';
import { localeToIsoLocaleString } from '@lessonup/utils';
import React from 'react';

export interface EmojiPollAnswerAreaContentViewProps {
  answers: PollPinAnswerDistribution<PollPinEmojiAnswer>[];
  showResults: boolean;
}

export function EmojiPollAnswerAreaContentView({ answers, showResults }: EmojiPollAnswerAreaContentViewProps) {
  const locale = useLocale();
  const percentageFormatter = new Intl.NumberFormat(localeToIsoLocaleString(locale), {
    style: 'percent',
    maximumFractionDigits: 0,
  });

  return (
    <StyledAnswerAreaContentWrapper direction="x" spacing={spacing.size8} justifyContent="center">
      {answers.map(({ answer, voteDistribution }) => {
        return (
          <SpaceBetween key={answer.id} style={{ position: 'relative' }} direction="y" spacing={spacing.size2}>
            <PollEmojiButton emoji={answer.text} size="large" as="div" />
            <StyledPinTag showResults={showResults}>
              <PinText textStyle="small-text">{percentageFormatter.format(voteDistribution)}</PinText>
            </StyledPinTag>
          </SpaceBetween>
        );
      })}
    </StyledAnswerAreaContentWrapper>
  );
}

const StyledAnswerAreaContentWrapper = styled(SpaceBetween)`
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const StyledPinTag = styled(PinTag)<{ showResults?: boolean }>`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, 0);
  ${({ showResults }) =>
    showResults
      ? css`
          transform: translate(-50%, 0);
          opacity: 0.75;
        `
      : css`
          transform: translate(-50%, 0);
          opacity: 0;
        `}
`;
